/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

/* eslint-disable import/prefer-default-export */
export const UPDATE_ORDER = 'mbp-checkout/UPDATE_ORDER';
